import { QueryClient } from "react-query"
import { VehicleRecordDataSourcesKey } from "./hooks/useVehicleRecordDataSources"
import { updateVehicleRecords } from "./updateVehicleRecords"

export async function fetchVehicleRecords(vehicleId: string, queryClient: QueryClient) {
    return updateVehicleRecords(vehicleId).then(() => {
        queryClient.invalidateQueries([VehicleRecordDataSourcesKey, vehicleId])
    })
}
